module.exports = __webpack_public_path__ + "static/media/14.007afa8f.jpg";